import { QueryKey, useQuery } from "@tanstack/react-query";
import { projectApi } from "../api/project";
import { queryClient } from "../../../shared/providers/QueryProvider";

export const useProjects = ({ searchKey, portfolioId, isPinned, quickFilters, phase_name, phase_type_id, page, limit }: { searchKey: string, portfolioId: string | undefined, isPinned: boolean, quickFilters: { region: string[] | null, programme: string[] | null, site: string[] | null }, phase_name: string | null, phase_type_id: number | null, page: number, limit: number }) => {

    const { data, isLoading, isError, refetch } = useQuery({
        queryKey: ["project-listing", searchKey, portfolioId, isPinned, quickFilters['region'], quickFilters['programme'], quickFilters['site'], phase_name, phase_type_id, page, limit] as QueryKey,
        queryFn: () => projectApi.fetchProjects({ search_term: searchKey, portfolio_id: portfolioId, is_pinned: isPinned, region_id: quickFilters["region"], programme_id: quickFilters["programme"], site_id: quickFilters["site"], phase_name, phase_type_id, page, limit }),
        enabled: phase_name !== null && phase_type_id !== null,
    });

    return {
        projectData: data?.data?.rows || [],
        isLoading,
        isError,
        pagination: data?.data?.pagination || {},
        refetch,
        removeCachePinned: () => { queryClient.removeQueries({ queryKey: ["project-listing", searchKey, portfolioId, true, quickFilters['region'], quickFilters['programme'], quickFilters['site'], phase_name, phase_type_id, page, limit] }); },
        removeCacheUnpinned: () => { queryClient.removeQueries({ queryKey: ["project-listing", searchKey, portfolioId, false, quickFilters['region'], quickFilters['programme'], quickFilters['site'], phase_name, phase_type_id, page, limit] }); }
    };

}